<template>
    <div id="desktop-navigation" v-if="data?.context !== 'general' && data?.context" class="hidden xl:block">
        <div
            class="bg-white"
            :class="[
                {
                    '!bg-transparent backdrop-filter-none xl:backdrop-blur-md': data?.context !== 'general',
                },
                { 'text-black': data?.context === 'men' },
            ]">
            <nav class="border-y border-green-500 py-[14px]">
                <ul class="normal-container flex flex-row gap-x-8">
                    <li
                        v-if="data?.context === 'ladies'"
                        v-for="navigationElementsChild in navigationElements.filter(
                            element =>
                                (element.type === 'page' && element.seoUrls?.[0]?.seoPathInfo === 'nl/dames/') ||
                                (element.type === 'link' && element.translated?.name === 'Dames'),
                        )[0]?.children"
                        class="flex items-center justify-center">
                        <NuxtLink
                            class="flex w-full items-center justify-between text-base font-semibold duration-300 hover:text-green-500"
                            :class="{
                                'sale-tag !text-sm':
                                    navigationElementsChild.translated &&
                                    navigationElementsChild.translated.customFields &&
                                    navigationElementsChild.translated.customFields['nd_menu_highlight_on'] === true,
                            }"
                            :to="
                                navigationElementsChild.seoUrls
                                    ? '/' + navigationElementsChild?.seoUrls[0]?.seoPathInfo
                                    : getUrlById(navigationElementsChild.internalLink) || undefined
                            ">
                            {{ navigationElementsChild?.translated?.name }}
                        </NuxtLink>
                    </li>
                    <li
                        v-if="data?.context === 'men'"
                        v-for="navigationElementsChild in navigationElements.filter(
                            element =>
                                (element.type === 'page' && element.seoUrls?.[0]?.seoPathInfo === 'nl/heren/') ||
                                (element.type === 'link' && element.translated?.name === 'Heren'),
                        )[0]?.children"
                        class="flex items-center justify-center">
                        <NuxtLink
                            class="flex w-full items-center justify-between py-1 text-base font-semibold duration-300 hover:text-green-500"
                            :class="{
                                'sale-tag !text-sm':
                                    navigationElementsChild.translated &&
                                    navigationElementsChild.translated.customFields &&
                                    navigationElementsChild.translated.customFields['nd_menu_highlight_on'] === true,
                            }"
                            :to="
                                navigationElementsChild.seoUrls
                                    ? '/' + navigationElementsChild?.seoUrls[0]?.seoPathInfo
                                    : getUrlById(navigationElementsChild.internalLink) || undefined
                            ">
                            {{ navigationElementsChild?.translated?.name }}
                        </NuxtLink>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script setup lang="ts">
    const { getUrlById } = useCategorySeoUrl();

    defineProps<{
        navigationElements: Array<any> | null;
        data: any;
    }>();
</script>
